import { render, staticRenderFns } from "./PageNotFound.vue?vue&type=template&id=af30549a&scoped=true&"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af30549a",
  null
  
)

export default component.exports